import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function masters() {
  const response = await http
    .getData("/skrining-paliatif-dewasa/masters")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function create(data: any) {
  const response = await http
    .postData("/skrining-paliatif-dewasa", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/skrining-paliatif-dewasa/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/skrining-paliatif-dewasa`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function timeline(pasienRm: string | number) {
  const response = await http
    .getData(`/skrining-paliatif-dewasa/by-pasien/${pasienRm}/timeline`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function latest(pasienRm: string | number) {
  const response = await http
    .getData(`/skrining-paliatif-dewasa/by-pasien/${pasienRm}/latest`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/skrining-paliatif-dewasa/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/skrining-paliatif-dewasa/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function markTindakLanjut(
  id: number,
  tlId: number,
  data: { status?: string; catatan_pelaksanaan?: string }
) {
  const response = await http
    .postData(`/skrining-paliatif-dewasa/${id}/tindak-lanjut/${tlId}/mark`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/skrining-paliatif-dewasa/${id}/pdf`, "_blank");
}

export default {
  masters,
  create,
  update,
  getByRegister,
  timeline,
  latest,
  find,
  destroy,
  markTindakLanjut,
  printPdf
};
